import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from "react";
import { request } from "../utils";
import { RouteHttpVerb } from "@tatum/utils";
import { showError } from "../utils/message";
export var useGet = function useGet(path) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  useEffect(function () {
    function fetchMyAPI() {
      return _fetchMyAPI.apply(this, arguments);
    }

    function _fetchMyAPI() {
      _fetchMyAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return request({
                  location: {
                    path: path,
                    method: RouteHttpVerb.GET
                  }
                });

              case 3:
                result = _context.sent;

                if ((result === null || result === void 0 ? void 0 : result.status) === "error" && result.message) {
                  showError(result);
                }

                setData(result);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                showError({
                  message: "An error occurred. Please contact support."
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
      return _fetchMyAPI.apply(this, arguments);
    }

    fetchMyAPI();
  }, []);
  return {
    data: data
  };
};